import {
  DEFAULT_ROW_HEIGHT,
  DEFAULT_HEADER_HEIGHT,
  DEFAULT_FOOTER_HEIGHT,
  DEFAULT_ROW_MARGIN,
  ONBOARDING_ROW_MARGIN,
  MOBILE_ROW_HEIGHT,
  MOBILE_HEADER_HEIGHT,
  DETAILED_DATA_GRID_CLASS_NAME,
  DETAILED_SMALL_TEXT_DATA_GRID_CLASS_NAME,
  MOBILE_ROW_HEIGHT_COMPACT,
  MOBILE_HEADER_HEIGHT_COMPACT,
  BORDER_HEIGHT,
  HORIZONTAL_SCROLLBAR_HEIGHT,
} from '../theme/constants/data-grid';

export const calculateBoxHeight = (dataGridStructure) => {
  const {
    gridRowCount,
    gridPageSize,
    page,
    height,
    actualRowHeight,
    rowMargin,
    footerHeight,
    headerHeight,
    scrollbarHeight = 0,
  } = dataGridStructure;

  const rowsDisplayed = Math.min(
    gridPageSize,
    gridRowCount - page * gridPageSize,
  );

  const rowTotal = rowsDisplayed * (actualRowHeight + rowMargin);
  return gridRowCount === 0 ? height : rowTotal + footerHeight + headerHeight + scrollbarHeight;
};

export const calculateTableBoxHeight = ({
  fitTableToContent,
  getRowHeight,
  loadingWithSkeleton,
  loadingSkeletonRowCount,
  maxHeight,
  ...boxHeightStructure
}) => {
  if (getRowHeight) {
    return maxHeight || boxHeightStructure.height || 'auto';
  }

  if (fitTableToContent) {
    const { gridRowCount, gridPageSize } = boxHeightStructure;
    const countForHeight = loadingWithSkeleton
      ? (loadingSkeletonRowCount ?? gridPageSize)
      : gridRowCount;

    return calculateBoxHeight({
      ...boxHeightStructure,
      gridRowCount: countForHeight,
    });
  }

  return calculateBoxHeight(boxHeightStructure);
};

export const calculateActualRowHeight = (rowHeight, isMobile, mobileDensity) => {
  if (rowHeight && mobileDensity === 'compact' && isMobile) return Math.floor(rowHeight * 0.7);
  if (rowHeight) return rowHeight;
  if (isMobile) return mobileDensity === 'compact' ? MOBILE_ROW_HEIGHT_COMPACT : MOBILE_ROW_HEIGHT;
  return DEFAULT_ROW_HEIGHT;
};

export const calculateHeaderHeight = (isMobile, mobileDensity) => {
  if (isMobile) return (mobileDensity === 'compact' ? MOBILE_HEADER_HEIGHT_COMPACT : MOBILE_HEADER_HEIGHT) + BORDER_HEIGHT;
  return DEFAULT_HEADER_HEIGHT + BORDER_HEIGHT;
};

export const calculateFooterHeight = (hideFooter = false) => (
  hideFooter ? 4 + BORDER_HEIGHT : DEFAULT_FOOTER_HEIGHT + BORDER_HEIGHT
);

// A fixed height either leaves a gap with overlay scrollbars or makes the grid overflow
// with classic scrollbars. Measure the horizontal bar height for the current browser/OS.
let cachedScrollbarHeight = null;

export const calculateScrollbarHeight = () => {
  if (cachedScrollbarHeight !== null) return cachedScrollbarHeight;
  if (typeof document === 'undefined') return HORIZONTAL_SCROLLBAR_HEIGHT;

  const probe = document.createElement('div');
  probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll;';
  document.body.appendChild(probe);
  cachedScrollbarHeight = probe.offsetHeight - probe.clientHeight;
  document.body.removeChild(probe);

  return cachedScrollbarHeight;
};

const DETAILED_DATA_GRID_CLASS_NAMES = [
  DETAILED_DATA_GRID_CLASS_NAME,
  DETAILED_SMALL_TEXT_DATA_GRID_CLASS_NAME,
];

export const calculateRowMargin = (dataGridClassName) => {
  if (DETAILED_DATA_GRID_CLASS_NAMES.includes(dataGridClassName)) {
    return ONBOARDING_ROW_MARGIN;
  }
  return DEFAULT_ROW_MARGIN;
};
